// @core/api/endpoints/workflow/get_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get pipeline by ID
 * Retrieves a pipeline by its unique identifier including status, trigger configuration, and version references.
 */
export async function GetPipeline(
  pipeline_id: string,
  options?: RequestOptions
): Promise<PipelineResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.get<PipelineResponse>(requestPath, { ...requestOptions });
}
